import { useEffect, useState } from 'react'
import FileUploadPicker from '..'
import { FileWrapper } from '../types/types'
import FilePickerInputItem from './FilePickerInputItem'
import { Button, Text } from '@bbl-digital/snorre-v2'
import { cn } from 'shared/utils/cn'

type FileuploadPickerInputProps = {
  className?: string
  initialFiles?: FileWrapper[]
  maxSizeInBytes?: number | undefined
  onChange?: (files: FileWrapper[]) => void
  onFileRemoved?: (file: FileWrapper) => void
  accept?: string
  reject?: string
  errorMsg?: string
  /**Deprecated: initial files should only be set initially */
  controlled?: boolean
  uploadButtonProps?: React.ComponentProps<typeof Button>
  hideSelectedFiles?: boolean
}

const FileuploadPickerInput = ({
  initialFiles,
  onChange,
  onFileRemoved,
  maxSizeInBytes,
  accept,
  reject,
  className,
  errorMsg,
  controlled = false,
  uploadButtonProps,
  hideSelectedFiles = false,
}: FileuploadPickerInputProps) => {
  const [files, setFiles] = useState<FileWrapper[]>(initialFiles || [])

  // Sync initialFiles if "controlled". Legacy and should not be used in future implementations
  // Remove when we re create email and case attachments
  useEffect(() => {
    if (!controlled) return
    setFiles(initialFiles || [])
  }, [initialFiles, controlled])

  if (reject && accept) {
    throw new Error(
      'FileuploadPickerInput Error: You cannot use both "accept" and "reject" props at the same time. Please choose one.'
    )
  }

  const handleSetFiles = (newFiles: FileWrapper[]) => {
    setFiles((prev) => {
      const updatedFiles = [...prev, ...newFiles]
      onChange?.(updatedFiles)
      return updatedFiles
    })
  }

  const handleRemoveFile = (file: FileWrapper) => {
    setFiles((prev) => {
      const updatedFiles = prev.filter((f) => f.id !== file.id)
      onChange?.(updatedFiles)
      return updatedFiles
    })

    if (file.isExisting) {
      onFileRemoved?.(file)
    }
  }

  const classes = cn('flex flex-col gap-1', className)

  return (
    <div className={classes}>
      {!hideSelectedFiles && files && files.length > 0 && (
        <div className="w-full">
          <Text className="font-semibold mb-1">Filnavn</Text>
          {files.map((file) => (
            <FilePickerInputItem
              key={file.id}
              file={file}
              removeFile={function (file: FileWrapper): void {
                handleRemoveFile(file)
              }}
            />
          ))}
        </div>
      )}

      <FileUploadPicker
        onChange={function (files: FileWrapper[]): void {
          handleSetFiles(files)
        }}
        maxSizeInBytes={maxSizeInBytes}
        accept={accept}
        reject={reject}
        uploadButtonProps={{ ...uploadButtonProps }}
      />
      {errorMsg && <Text className="text-ui-errorDark">{errorMsg}</Text>}
    </div>
  )
}
export default FileuploadPickerInput
